module.exports = __webpack_public_path__ + "assets/img/title_sign.1a73a5d8.png";